import React from 'react'

export default function EventRoot() {
  return null
}
